import React from 'react';
import { experience } from '../../data/experience';
export function ExperienceList() {
  return <div className="mt-20 md:mt-28" data-id="element-39" data-mp="6bp71girwing">
      <div className="mb-8" data-id="element-40" data-mp="6anokqzfgtvp">
        <h3 className="text-3xl tracking-tight md:text-4xl" style={{
        color: 'var(--fg)'
      }} data-id="element-41" data-mp="6el5d5yj99cf">
          Experience and impact
        </h3>
      </div>

      <ol style={{
      borderTop: '1px solid var(--fg)'
    }} data-id="element-42" data-mp="3skgodx8bgefg">
        {experience.map(item => <li key={item.company} className="grid grid-cols-1 gap-2 py-7 md:grid-cols-12 md:gap-8 md:py-8" style={{
        borderBottom: '1px solid var(--border)'
      }} data-id="element-43" data-mp="u0rqmtwywlkl">
            <p className="font-aspekta text-sm tabular-nums md:col-span-2 md:pt-1.5" style={{
          color: 'var(--muted)'
        }} data-id="element-44" data-mp="kaoy0utrd9ms">
              {item.period}
            </p>
            <div className="md:col-span-3" data-id="element-45" data-mp="1cs1238qatket">
              <p className="font-aspekta text-xl tracking-tight" style={{
            color: 'var(--fg)'
          }} data-id="element-46" data-mp="1ctvm8ktqx8hu">
                {item.company}
              </p>
              <p className="mt-1 text-sm" style={{
            color: 'var(--muted)'
          }} data-id="element-47" data-mp="2k8nxe692i9ff">
                {item.role}
              </p>
              <p className="text-sm" style={{
            color: 'var(--muted)'
          }} data-id="element-48" data-mp="2oa975iqb27le">
                {item.location}
              </p>
            </div>
            <p className="text-base leading-relaxed md:col-span-5" style={{
          color: 'var(--fg)'
        }} data-id="element-49" data-mp="2aicijonuiftr">
              {item.impact}
            </p>
            <div className="mt-2 md:col-span-2 md:mt-0 md:text-right" data-id="element-50" data-mp="20kool0y2dccn">
              <p className="font-aspekta whitespace-nowrap text-3xl tracking-tight md:text-4xl" style={{
            color: 'var(--accent)'
          }} data-id="element-51" data-mp="20mrl83tq23qc">
                {item.metric}
              </p>
              <p className="font-aspekta text-sm" style={{
            color: 'var(--muted)'
          }} data-id="element-52" data-mp="1rll2do3logtx">
                {item.metricLabel}
              </p>
            </div>
          </li>)}
      </ol>
    </div>;
}